import { render, staticRenderFns } from "./PrintPosFacturaRegular.vue?vue&type=template&id=56292c37&scoped=true"
import script from "./PrintPosFacturaRegular.vue?vue&type=script&lang=js"
export * from "./PrintPosFacturaRegular.vue?vue&type=script&lang=js"
import style0 from "./PrintPosFacturaRegular.vue?vue&type=style&index=0&id=56292c37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56292c37",
  null
  
)

export default component.exports